export default __webpack_public_path__ + "static/media/ver-poor-icon.5144c157.svg";